<template>
  <div class="user-dropdown-button" @click="openUserButton = !openUserButton">
    <div class="button">
      <span class="name">{{user.email}}</span>
      <span class="role" v-if="user.level.id == 11">administrator</span>
      <span class="role" v-if="user.level.id == 12">pracownik</span>
      <chevron-down-icon v-if="!openUserButton" title />
      <chevron-up-icon v-if="openUserButton" title />
    </div>

    <div class="dropdown-button-menu" :class="{'open': openUserButton}">
      <ul>
        <li @click="goToAccount()">
          <account-icon title="Moje konto" />
          <span class="text">Moje konto</span>
        </li>
        <li @click="logout()">
          <power-icon title="Wyloguj" />
          <span class="text">Wyloguj</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";
import AccountIcon from "vue-material-design-icons/Account.vue";
import PowerIcon from "vue-material-design-icons/Power.vue";
import ChevronUpIcon from "vue-material-design-icons/ChevronUp.vue";

export default {
  components: {
    ChevronUpIcon,
    PowerIcon,
    AccountIcon,
    ChevronDownIcon
  },
  computed: {
    ...mapState({
      user: state => state.user.authorizedUser
    })
  },
  data() {
    return {
      openUserButton: false
    };
  },
  methods: {
    goToAccount() {
      this.$router.replace({ name: "account" });
    },

    async logout() {
      await this.$store.dispatch("user/signout");
      this.$router.go("/");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/src/button/UserDropDownButton.vue